import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Checkbox } from 'opencare-crown';

import {
  PromoSmsConsentCheckboxContainer,
  PromoSmsConsentCheckboxLabel,
} from './styled-components';

const PromoSmsConsentCheckbox = ({ onChange, disabled }) => {
  const [promoSmsAllowed, setPromoSmsAllowed] = useState(null);

  useEffect(() => {
    onChange(promoSmsAllowed);
  }, [promoSmsAllowed]);

  return (
    <PromoSmsConsentCheckboxContainer>
      <Checkbox
        checked={promoSmsAllowed}
        onChange={(e) => setPromoSmsAllowed(e.target.checked)}
        disabled={disabled}
      />
      <PromoSmsConsentCheckboxLabel
        onClick={() => !disabled && setPromoSmsAllowed(!promoSmsAllowed)}
      >
        I agree to receive SMS with promotional content at the phone number
        provided above.
      </PromoSmsConsentCheckboxLabel>
    </PromoSmsConsentCheckboxContainer>
  );
};

PromoSmsConsentCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default PromoSmsConsentCheckbox;
